export default __webpack_public_path__ + "static/media/hubnai.8fa4f29c.ico";